<template>
  <div>
    <el-dialog
      :visible.sync="recordDialogVisible"
      title="产品基础属性查看"
      width="70%"
      @cancel="updateVal"
      @close="updateVal"
    >
      <div>
        <el-table
            border
            :data="overviewData"
            max-height="calc(100% - 20px)"
          >
            <el-table-column prop="photoUrl" width="50px" label="图片">
              <template slot-scope="scope">
                <template v-if="showDetailBtn(scope.row)">
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="showDialog(scope.row, 0)"
                    >查看</el-link
                  >
              </template> 
            </template>
            </el-table-column>
            <el-table-column prop="productCode" show-overflow-tooltip label="产品编码"></el-table-column>
            <el-table-column prop="productName" width="160px" show-overflow-tooltip label="产品名称"> </el-table-column>
            <el-table-column prop="marketDate" width="100px" show-overflow-tooltip label="上市时间"> </el-table-column>
            <el-table-column prop="style" label="风格"> </el-table-column>
            <el-table-column prop="material" label="材质">
            </el-table-column>
            <el-table-column prop="color" label="颜色"> </el-table-column>
            <el-table-column prop="specDesc" label="规格"> </el-table-column>
            <el-table-column prop="productSize" label="尺寸"> </el-table-column>
            <el-table-column prop="saleNumTotal" label="全网销量"> </el-table-column>
            <el-table-column prop="saleNum" width="110px" label="当前店铺销量"> </el-table-column>
            <el-table-column prop="price" width="130px" label="日常活动到手价"> </el-table-column>
            <el-table-column prop="minSaleAmount" width="120px" label="最低成交金额" v-if=" overviewData.length && overviewData[0].amountHideFlag === '0'"> </el-table-column>
          </el-table>
      </div>
    </el-dialog>
    <pic-video
      v-model="picVideoVisible"
      :data="rowData"
      :detailType="viewType"
      v-if="picVideoVisible"
    ></pic-video>
  </div>
</template>

<script>
import {assignValue} from '@/utils'
import picVideoMxin from "../pic&video.mixin";
export default {
  mixins: [picVideoMxin],
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    overviewData: Array
  },
  computed: {
  },
  data() {
    return {
      recordDialogVisible: false,
      tableData: [],
      imgData:[]
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.recordDialogVisible = this.visible;
    },

    updateVal() {
      setTimeout(_=>{
        this.$emit('overviewDialog', false)
      },200)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .backPlay{
    &:hover{
      opacity: 1
    }
  }
  .el-button--whiteBackground {
      opacity: .7;
      font-size: 12px
      position: absolute;
      padding: 5px 7px
      right: 10px
      bottom: 10px
      color: #FFF;
      background-color: #0BB78E;
      border-color: #0BB78E;
  }

  .no-data
    display: flex;
    align-items: center
    justify-content: center
    color #999999
    padding 40px 0

  .imgSize {
    width: 100%;
    height: 280px
  }
</style>>

